import { UserResolveMatchSchema, UserResolveResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type UserResolveMatchInput = z.input<typeof UserResolveMatchSchema>;
export type UserResolveMatchOutput = z.output<typeof UserResolveMatchSchema>;

export function serializeUserResolveMatch(payload: UserResolveMatchInput): UserResolveMatchOutput {
  return UserResolveMatchSchema.parse(payload);
}

export type UserResolveResponseInput = z.input<typeof UserResolveResponseSchema>;
export type UserResolveResponseOutput = z.output<typeof UserResolveResponseSchema>;

export function serializeUserResolveResponse(payload: UserResolveResponseInput): UserResolveResponseOutput {
  return UserResolveResponseSchema.parse(payload);
}
